import React, {useEffect, useState, useRef, useContext} from 'react';
import Styles from 'styles/sticky_cart_feature_preview.module.scss'
import PreviewContext from 'context/PreviewContext';
import { CartContext } from "components/cart";

const StickyCart = ({settings,money_format,isPreview, device, product}) => {
    
    const SC = settings.sticky_cart
    // const {
	// 	cart_currency
	// } = useContext(CartContext);
    const {
        isUnavailableFocused,
		isStickyActVariantFocused,
        setIsStickyActVariantFocused
    } = useContext(PreviewContext);

    const [variants, setVariants] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const [qte, setQte] = useState(1)

    let price = product.variants[0].price
    let oldPrice = product.variants[0].compare_at_price || 0
    
   
    const formatColor = (color) => {
        if (!color)
            color = {
                r: 0,
                g: 0,
                b: 0,
                a: 1,
            };
        return typeof color === 'string' ? color : `rgba(${color.r},${color.g},${color.b},${color.a})`;
    };
    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    }
    const formatMoney = (n, money_format = '${{amount}}') =>
        money_format
		.replace(/{{\s*?amount\s*?}}/g, formatWithDelimiters(n, 2))
		.replace(/{{\s*?amount_with_decimal_separator\s*?}}/g, formatWithDelimiters(n, 2))
		.replace(/{{\s*?amount_no_decimals\s*?}}/g, formatWithDelimiters(n, 0))
		.replace(/{{\s*?amount_with_comma_separator\s*?}}/g, formatWithDelimiters(n, 2, ".", ","))
		.replace(/{{\s*?amount_no_decimals_with_comma_separator\s*?}}/g, formatWithDelimiters(n, 0, ".", ","))
		.replace(/{{\s*?amount_with_apostrophe_separator\s*? }}/g, formatWithDelimiters(n, 2, "'", "."))
		.replace(/{{\s*?amount_no_decimals\s*? }}/g, formatWithDelimiters(n, 2, "'", "."));

    
    useEffect(() => {

        const selectedVariants = {}

        product.options.forEach(option => {
            selectedVariants['option' + option.position] = option.name
        })
        setVariants(
            selectedVariants
        )


        // auto close the selects
        window.addEventListener('click', function (e) {
            const selects = document.querySelectorAll('[data-open="open"]')
            // console.log(selects)
            selects.forEach(select => {
                if (select && !select.contains(e.target)) {
                    select.dataset.open = "close"
                }
            })

        });

    }, [])

    const changeSelect = (value, position) => {
        let tmpVariants = variants
        tmpVariants['option' + position] = value
        setVariants(
            {...tmpVariants}
        )
    }
    const handleMobileAtcClick = () => {
        if (SC.mobile_show_quantity || SC.mobile_show_variants) setIsOpen(!isOpen)
    }

    useEffect(() => {
        if (!SC.mobile_show_quantity && !SC.mobile_show_variants) setIsOpen(false)
    }, [SC.mobile_show_quantity, SC.mobile_show_variants])

    const toggleOpen = (element) => {
        // element.currentTarget.focus()
        const state = element.currentTarget.dataset.open
        element.currentTarget.dataset.open = state === "open" ? "close" : "open"
    }

    const qtes = []
    for (let i = 1; i < 16; i++)
        qtes.push(i)
    const mobile_cart_position = SC.mobile_location
    return (
        <>
            {device === "desktop" &&
            <div
                className={`${Styles.desktopStickyCartContainar} ${SC.btn_style === "curvy" && Styles.curvy}`}
                style={{
                    background: formatColor(SC.background_color),
                    bottom: '10px',
                    opacity: 1,
                    visibility: SC.desktop_active ? "visible" : "hidden",
                }}>
                <div className={Styles.detailsSection}>
                    {SC.desktop_product_preview && product.images.length && (product.images[0].src || typeof (product.images[0]) === "string") &&
                    <img
                        src={product.images[0].src || product.images[0]}
                        alt="product image"
                        className={Styles.image}
                    />
                    }

                    <div className={Styles.details}>
                        {SC.desktop_show_product_name &&
                        <div className={Styles.title}>
                            {product.title}
                        </div>
                        }
                        <span className={Styles.price}>
                            {SC.desktop_show_compared_price && oldPrice != 0 &&
                                <span className={Styles.oldPrice} dangerouslySetInnerHTML={{ __html:  formatMoney(oldPrice, money_format) }}></span>
                            }
                            <span style={{color: formatColor(SC.btn_color)}}  dangerouslySetInnerHTML={{ __html:  formatMoney(price, money_format) }}></span>
                        </span>
                    </div>
                </div>
                <div className={Styles.actionsSection}>

                    {SC.desktop_show_variants && product.variants.length > 1 &&
                    product.options.map((option, id) => {
                        return (
                            <div className={` ${Styles.map_select_containar} `} key={id}>
                                <div className={` ${Styles.label} `}>
                                    {option.name}
                                </div>
                                <div
                                    key={"options-" + id}
                                    className={` ${Styles.map_select} `}
                                    data-open="close"
                                    onClick={(e) => toggleOpen(e)}
                                >

                                    <span className={Styles.current}> {option.values[0]} </span>
                                    <ul className={Styles.list}  style={{bottom : "68px"}}>
                                        {
                                            option.values.map((value, id) => <li key={id} data-value={id}
                                                                                 data-display={value}
                                                                                 className={` ${Styles.option} ${id === 0 && Styles.selected} `}>{value}</li>)
                                        }
                                    </ul>
                                </div>
                            </div>
                        )
                    })
                    }

                    {SC.desktop_show_quantity &&

                    <div>
                        <div className={` ${Styles.label} `}>
                            {SC.desktop_quantity.text }
                        </div>
                        <div className={Styles.qte}>
                            <span onClick={() => setQte(qte < 2 ? 1 : parseInt(qte, 10) - 1)}
                                  className={Styles.minus}>-</span>
                            <input
                                type="number"
                                value={qte}
                                min={1}
                            />
                            <span onClick={() => setQte(parseInt(qte, 10) + 1)} className={Styles.minus}>+</span>
                        </div>
                    </div>
                    }

                    <div
                        className={Styles.atc}
                        style={{
                            background: formatColor(SC.btn_color),
                            color: formatColor(SC.txt_color),
                        }}
                    >
                        {isUnavailableFocused ? SC.btn_text_unavailable : SC.btn_text}
                        {/* BUY NOW */}
                    </div>
                </div>
            </div>
            }
            {
                device === "mobile" &&
                <>
                    <div
                        className={`${Styles.background}`}
                        data-open={isOpen}
                        onClick={() => setIsOpen(false)}
                    ></div>
                    <div
                        className={Styles.mobileStickyCartContainar}
                        style={{
                            background: formatColor(SC.background_color),
                            [mobile_cart_position]: 0,
                            opacity: 1,
                        }}
                    >
                        <div className={`${Styles.actionsSection}`} data-open={isOpen}>
                            {!isOpen ?
                                SC.mobile_show_title || SC.mobile_show_price ?
                                    <div className={Styles.infos}>
                                        <span className={Styles.title}> { SC.mobile_show_title && product.title} </span>
                                        {
                                            SC.mobile_show_price &&
                                                <span className={Styles.price} style={{color: formatColor(SC.btn_color)}}>
                                                    {SC.mobile_show_compared_price && oldPrice != 0 &&
                                                        <span className={Styles.oldPrice}  dangerouslySetInnerHTML={{ __html:  formatMoney(oldPrice, money_format) }}></span>
                                                    }
                                                    <span className={Styles.current} dangerouslySetInnerHTML={{ __html:  formatMoney(price, money_format) }} ></span>
                                                </span>
                                        }
                                    </div>
                                    :
                                    null
                                :
                                <div className={Styles.cart}>
                                    <div className={Styles.header}>
                                        <div className={Styles.txt}>
                                            <svg width="19" height="18" viewBox="0 0 19 18" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M4.64135 0.422363H0.53125V2.13789H3.29187L5.66684 13.0122H5.67782V13.2888H16.8287V13.076L18.71 4.78919L18.9995 3.85341H5.38207L4.89284 1.61338L4.64135 0.422363ZM16.8175 5.56893H5.75674L7.06809 11.5733H15.4544L16.8175 5.56893Z"
                                                      fill="#393939"/>
                                                <path
                                                    d="M8.25166 17.5776C9.19914 17.5776 9.96718 16.8096 9.96718 15.8621C9.96718 14.9146 9.19914 14.1465 8.25166 14.1465C7.3042 14.1465 6.53613 14.9146 6.53613 15.8621C6.53613 16.8096 7.3042 17.5776 8.25166 17.5776Z"
                                                    fill="#393939"/>
                                                <path
                                                    d="M15.9711 15.8621C15.9711 16.8096 15.203 17.5776 14.2556 17.5776C13.3081 17.5776 12.54 16.8096 12.54 15.8621C12.54 14.9146 13.3081 14.1465 14.2556 14.1465C15.203 14.1465 15.9711 14.9146 15.9711 15.8621Z"
                                                    fill="#393939"/>
                                            </svg>
                                            {SC.cart_name.text}
                                            <div className={Styles.close} onClick={() => setIsOpen(false)}>
                                                <svg width="11" height="11" viewBox="0 0 12 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
                                                        fill="#959595"/>
                                                </svg>
                                            </div>
                                        </div>

                                    </div>
                                    <div className={Styles.body}>
                                        <div className={Styles.infos}>
                                            {product.images.length && (product.images[0].src || typeof (product.images[0]) === "string") &&
                                            <img
                                                src={product.images[0].src || product.images[0]}
                                                alt="product image"
                                                className={Styles.image}
                                            />
                                            }
                                            <span className={Styles.title}> {product.title} </span>
                                            <span className={Styles.price} style={{color: formatColor(SC.btn_color)}}>
                                                {
                                                    SC.mobile_show_compared_price && oldPrice != 0 && 
                                                        <span className={Styles.oldPrice} dangerouslySetInnerHTML={{ __html:  formatMoney(oldPrice, money_format) }} ></span>
                                                }
                                                <span dangerouslySetInnerHTML={{ __html:  formatMoney(price, money_format) }} ></span>
                                            </span>
                                        </div>
                                        {SC.mobile_show_quantity &&
                                        <div className={` ${Styles.row} `}>
                                            <div className={` ${Styles.label} `}>
                                                {SC.mobile_quantity.text}
                                            </div>
                                            <div className={Styles.qte}>
                                                <span onClick={() => setQte(qte < 2 ? 1 : parseInt(qte, 10) - 1)}
                                                      className={Styles.minus}>-</span>
                                                <input
                                                    type="number"
                                                    value={qte}
                                                    min={1}
                                                />
                                                <span onClick={() => setQte(parseInt(qte, 10) + 1)}
                                                      className={Styles.minus}>+</span>
                                            </div>
                                        </div>
                                        }
                                        {SC.mobile_show_variants && product.variants.length > 1 &&
                                        product.options.map((option, id) => {
                                            return (
                                                <div className={` ${Styles.row} `} key={id}>
                                                    <div className={` ${Styles.label} `}>
                                                        {option.name}
                                                    </div>
                                                    <div
                                                        key={"options-" + id}
                                                        className={` ${Styles.map_select} `}
                                                        data-open="close"
                                                        onClick={(e) => toggleOpen(e)}
                                                    >

                                                        <span className={Styles.current}> {option.values[0]} </span>
                                                        <ul className={Styles.list}  style={{bottom : "68px"}}>
                                                            {
                                                                option.values.map((value, id) => <li key={id}
                                                                                                     data-value={id}
                                                                                                     data-display={value}
                                                                                                     className={` ${Styles.option} ${id === 0 && Styles.selected} `}>{value}</li>)
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                </div>

                            }
                            <div
                                className={Styles.atc}
                                style={{
                                    background: formatColor(SC.btn_color),
                                    color: formatColor(SC.txt_color),
                                    height: SC.mobile_atc_height.text + "px"
                                }}
                                onClick={handleMobileAtcClick}
                            >
                                {isUnavailableFocused ? SC.btn_text_unavailable :
                                    isOpen ?  SC.btn_text_variant_active :
                                        (isStickyActVariantFocused && SC.show_btn_atc_txt_variant_active) ? SC.btn_atc_txt_variant_active : SC.btn_text 
                                }
                            </div>
                        </div>
                    </div>
                </>
            }

        </>

    )
}


export default StickyCart

